import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

// Native <select> com estilo do design system. Para combobox/multiselect, criar primitiva nova com Radix.
//
// Chevron: appearance:none + SVG inline na background-image (cor neutra `--text-2`).
// Sem isso, o browser desenha seta nativa que destoa do DS e escala mal em fontes menores
// (ex: text-[0.82rem] dentro de popovers — seta ficava estourando à direita).
const CHEVRON_SVG =
  "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23a5a097' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, style, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'h-10 w-full rounded-md bg-elevated border pl-2.5 pr-8 text-sm text-text',
        'appearance-none bg-no-repeat',
        'transition-colors focus:outline-none cursor-pointer',
        invalid ? 'border-danger' : 'border-border hover:border-border2',
        'disabled:opacity-60 disabled:cursor-not-allowed',
        className,
      )}
      style={{
        backgroundImage: CHEVRON_SVG,
        backgroundPosition: 'right 0.65rem center',
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  );
});
